import type { OutboxItem } from '../offline/outbox'

// Dead-Letter-Recovery: macht endgültig fehlgeschlagene Schreibvorgänge (v. a. Stempel) SICHTBAR — bisher
// landeten sie stumm im Bucket (loadFailedOutbox hatte keinen Verwender), der Nutzer erfuhr nie vom Verlust.
// v1: auflisten + verwerfen (nachdem der Nutzer neu gestempelt / dem Chef gemeldet hat). Der automatische
// Nachtrag als Korrekturantrag kommt mit dem Nachzügler-Pfad (R2).

const STAMP_LABEL: Record<string, string> = {
  kommen: 'Kommen',
  gehen: 'Gehen',
  pause_start: 'Pause',
  pause_ende: 'Pause beenden',
}

function describeItem(it: OutboxItem): string {
  const when = new Date(it.createdAt).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
  if (it.path === 'attendance') {
    const kind = typeof it.body.kind === 'string' ? it.body.kind : ''
    return `${STAMP_LABEL[kind] ?? 'Stempel'} · ${when}`
  }
  return `Zeitbuchung · ${when}`
}

export function DeadLetterPanel({ items, onDiscard }: { items: OutboxItem[]; onDiscard: (id: string) => void }) {
  return (
    <div className="wf-conn__panel" role="dialog" aria-label="Nicht gespeicherte Stempel">
      <p className="wf-conn__panelhd">
        Diese Stempel konnten nicht gespeichert werden. Bitte neu stempeln oder dem Chef als Korrektur melden — dann
        kannst du sie hier verwerfen.
      </p>
      <ul className="wf-conn__panellist">
        {items.map((it) => (
          <li key={it.id}>
            <span>{describeItem(it)}</span>
            <button type="button" className="wf-btn wf-btn--sm wf-btn--ghost" onClick={() => onDiscard(it.id)}>
              Verwerfen
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
